<template>
	<div class="title-bar">
		<div class="title-bar__left">
			<img style="height: 40px" src="../../assets/img/logo/logo1.png" />
			<img src="../../assets/img/logo/logo2.png" />
			<span class="title-bar__title">{{ systemTitle }}</span>
		</div>
		<div class="one"></div>
		<div class="title-bar__right" @click.stop="clickUser">
			<el-tooltip content="使用说明" placement="bottom" effect="dark">
				<div class="title-bar__guide" @click.stop="goGuide">
					<i class="el-icon-notebook-2 title-bar__guide-icon"></i>
				</div>
			</el-tooltip>
			<el-popover popper-class="wxxcx-popover" placement="bottom-end" trigger="hover" width="220">
				<div class="wxxcx-pop">
					<img class="wxxcx-img" src="../../assets/image/wxxcx.jpg" alt="微信小程序" />
					<div class="wxxcx-text">微信小程序</div>
				</div>
				<div slot="reference" class="title-bar__wxxcx" @click.stop>
					<svg class="title-bar__wxxcx-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
						<path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05a6.127 6.127 0 0 1-.225-1.696c0-3.573 3.469-6.47 7.748-6.47.21 0 .416.018.622.03C16.819 4.912 13.112 2.188 8.691 2.188zM5.592 5.808c.617 0 1.117.486 1.117 1.086 0 .6-.5 1.086-1.117 1.086a1.108 1.108 0 0 1-1.118-1.086c0-.6.5-1.086 1.118-1.086zm6.177 0c.617 0 1.117.486 1.117 1.086 0 .6-.5 1.086-1.117 1.086a1.108 1.108 0 0 1-1.118-1.086c0-.6.5-1.086 1.118-1.086zM18.572 9.686c.18 0 .361.012.539.029-1.005-3.106-4.081-5.416-7.736-5.416-4.52 0-8.178 3.105-8.178 6.926 0 1.974 1.046 3.818 2.864 5.028l-.687 2.41c-.06.21.136.394.344.32l2.211-1.121c.581.14 1.15.253 1.744.305a6.137 6.137 0 0 1-.147-1.334c0-3.802 3.61-6.879 8.06-6.879.276 0 .55.017.82.041zM16.7 12.246c-.416 0-.754-.329-.754-.736 0-.406.338-.735.754-.735s.754.329.754.735c0 .407-.338.736-.754.736zm3.228 0c-.416 0-.754-.329-.754-.736 0-.406.338-.735.754-.735s.754.329.754.735c0 .407-.338.736-.754.736zm-1.614 2.318c-2.826 0-5.117 1.944-5.117 4.342 0 2.397 2.291 4.341 5.117 4.341.664 0 1.293-.105 1.874-.314l1.442.732a.25.25 0 0 0 .363-.27l-.463-1.594c1.173-.776 1.941-1.996 1.941-3.364 0-2.398-2.291-4.342-5.117-4.342zm-1.612 2.398c.276 0 .503.224.503.5a.502.502 0 0 1-.503.5.502.502 0 0 1-.503-.5c0-.276.227-.5.503-.5zm3.224 0c.276 0 .503.224.503.5a.502.502 0 0 1-.503.5.502.502 0 0 1-.503-.5c0-.276.227-.5.503-.5z" />
					</svg>
				</div>
			</el-popover>
			<div class="title-bar__message" @click.stop="goMessage">
				<el-badge :value="messageNum" :hidden="messageNum === 0" :max="99" class="tb-badge">
					<i class="el-icon-message title-bar__message-icon"></i>
				</el-badge>
			</div>
			<!-- <img class="title-bar__user_avatar" src="../../assets/img/nav/defaultAvatar.png" @click.stop="clickUser" /> -->
			<img v-if="userPhoto" class="title-bar__user_avatar" :src="userPhoto" />
			<span v-else class="title-bar__user_avatar title-bar__user_avatar--text">{{ (userInfo.chName || "用").slice(-2) }}</span>
			<span class="title-bar__user_name">{{ userInfo.chName }}【{{ userInfo.userName }}】</span>
		</div>
		<navTip ref="navTip" @user-info-click="userInfoClick" @click-change-pwd="clickChangePwd"></navTip>
		<userInfoD ref="userInfoD"></userInfoD>
		<changepwd ref="changepwd"></changepwd>
	</div>
</template>

<script>
import userInfoD from "../../views/system/user/userInfo.vue";
import changepwd from "../../views/system/user/changepwd.vue";
import navTip from "./navTip.vue";
import { GetUnreadMessageNum } from "../../api/systemApi.js";
export default {
	data() {
		return {
			userInfo: {},
			userPhoto: "",
			systemTitle: "",
			// 未读站内信数量
			messageNum: 0,
			// 未读数定时器
			msgTimer: null
		};
	},
	computed: {
		GetsystemTitle() {
			// 从环境变量中获取系统标题，如果不存在则使用默认值
			return process.env.VUE_APP_SYSTEM_TITLE || "应用系统";
		}
	},
	components: {
		navTip,
		userInfoD,
		changepwd
	},
	created() {
		// 从Vuex store获取配置信息
		this.systemTitle = process.env.VUE_APP_SYSTEM_TITLE || "应用系统";
		// 监听消息已读/删除后刷新未读数
		this.$root.Bus.$on("message-refresh", this.refreshUnread);
	},
	mounted() {
		this.$nextTick(() => {
			this.getUserInfo();
			this.refreshUnread();
		});
		// 每 60 秒定时刷新未读数
		this.msgTimer = setInterval(this.refreshUnread, 60000);
	},
	beforeDestroy() {
		clearInterval(this.msgTimer);
		if (this.$root.Bus && this.$root.Bus.$off) {
			this.$root.Bus.$off("message-refresh", this.refreshUnread);
		}
	},
	methods: {
		// 获取用户信息
		getUserInfo() {
			if (localStorage.getItem("userdata")) {
				this.userInfo = JSON.parse(localStorage.getItem("userdata")).userInfo;
				if (this.userInfo.photoImg) {
					this.userPhoto = "data:image/png;base64," + this.userInfo.photoImg;
				}
			}
		},

		// 刷新未读站内信数量
		refreshUnread() {
			let userdata = JSON.parse(localStorage.getItem("userdata")) || {};
			let receiveUserId = (userdata.userInfo && userdata.userInfo.keyId) || "";
			if (!receiveUserId) return;
			GetUnreadMessageNum({ receiveUserId: receiveUserId })
				.then((res) => {
					if (res.code == 1) {
						this.messageNum = res.data || 0;
					}
				})
				.catch((err) => {});
		},

		// 跳转站内信列表
		goMessage() {
			this.$router.push({
				path: "/system/message"
			});
		},

		// 跳转使用说明
		goGuide() {
			this.$router.push({
				path: "/system/usageGuide"
			});
		},

		// 更改密码
		clickChangePwd() {
			this.$refs.changepwd.showChangePwdDialog();
		},

		// 点击个人信息
		userInfoClick() {
			this.$refs.userInfoD.showUserInfoDialog(this.userInfo);
		},
		// 点击用户头像
		clickUser() {
			this.$refs.navTip.showTip(this.userInfo);
		},

		// 关闭应用
		quit() {
			this.$confirm("关闭应用, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				// 在Web环境中无法直接控制窗口，这里仅作提示
				this.$message.info("在Web环境中无法直接关闭应用");
			});
		}
	}
};
</script>

<style scoped>
.title-bar {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: linear-gradient(90deg, #16307b 0%, #1e40af 100%);
	height: 3.5rem;
	color: #ffffff;
	padding: 0 18px;
	box-sizing: border-box;
	box-shadow: 0 2px 12px rgba(15, 23, 42, 0.18);
	-webkit-app-region: drag;
}

.title-bar__message {
	margin-right: 18px;
	margin-left: 6px;
	display: flex;
	align-items: center;
	cursor: pointer;
	-webkit-app-region: no-drag;
	font-size: 22px;
	color: #ffffff;
	line-height: 1;
}

.title-bar__message:hover {
	color: #ffd04b;
}

.title-bar__message-icon {
	font-size: 22px;
	vertical-align: middle;
}

.title-bar__wxxcx {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	margin-right: 18px;
	border-radius: 5px;
	cursor: pointer;
	-webkit-app-region: no-drag;
}

.title-bar__wxxcx:hover {
	background: #55aaff;
}

.title-bar__guide {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	margin-right: 18px;
	border-radius: 5px;
	cursor: pointer;
	-webkit-app-region: no-drag;
	color: #ffffff;
	transition: background-color 0.2s ease;
}

.title-bar__guide:hover {
	background: #55aaff;
}

.title-bar__guide-icon {
	font-size: 20px;
	line-height: 1;
}

.title-bar__wxxcx-icon {
	width: 20px;
	height: 20px;
	display: block;
}

.wxxcx-pop {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.wxxcx-img {
	width: 180px;
	height: 180px;
	object-fit: contain;
}

.wxxcx-text {
	margin-top: 8px;
	font-size: 13px;
	color: #475569;
}

.title-bar__user_avatar {
	width: 30px;
	height: 30px;
	margin-left: 14px;
	border: 1px solid #fff;
	border-radius: 50%;
	-webkit-app-region: no-drag;
	object-fit: cover;
}

.title-bar__user_avatar--text {
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #409eff 0%, #5cadff 100%);
	color: #fff;
	font-size: 13px;
	font-weight: 600;
	flex-shrink: 0;
	box-sizing: border-box;
}

.title-bar__user_name {
	color: #ffffff;
	margin-left: 12px;
	font-size: 13px;
	white-space: nowrap;
}

.title-bar__title {
	margin-left: 12px;
	font-weight: 600;
	font-size: 20px;
	letter-spacing: 1px;
	font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.title-bar__right {
	margin-right: 0;
}

.title-bar__icon {
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	cursor: pointer;
}

.title-bar__icon:hover {
	background: #55aaff;
}

.title-bar__icon img {
	width: 20px;
	height: 20px;
}

.tbi_img {
	width: 18px !important;
	height: 18px !important;
}

.title-bar__left,
.title-bar__right {
	display: flex;
	align-items: center;
	min-width: 0;
	/* -webkit-app-region: drag; */
}
.title-bar__left img {
	width: auto;
	height: 38px;
}
/* /deep/ .el-input__inner {
		background: #6996ff;
		color: #ffffff;
		border: none;
	} */

.one {
	display: flex;
	align-items: center;
	flex: 1;
	justify-content: center;
	-webkit-app-region: no-drag;
}

.one_1 {
	font-size: 20px;
	margin-right: 10px;
}

.one_2 {
	width: 450px;
}
</style>

<style>
.wxxcx-popover {
	overflow: visible !important;
	max-height: none !important;
	padding: 12px;
}
</style>
